
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
export default {
  name: "QdapHomeProductCardSponsorPromotion",
  mixins: [eventTrackingMixins],
  props: {
    data: {
      type: Object,
      default: () => { },
    },
  },

  async mounted() {
    await this.$nextTick();
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  updated() {
  },

  methods: {
    openPopUp(id) {
      this.$bvModal.show(id);
      // this.$bvModal.show(this.data.scenarioId + '_' + this.data.promotionId);
      this.handleEventTracking()
    },

    // #194 {product_id}	open_promo_details	qdap_products_promo_banner
    handleEventTracking(){
        const eventTrackingParams = this.initEventTrackingParams()

        eventTrackingParams.a = 'open_promo_details' 
        eventTrackingParams.c = 'qdap_products_promo_banner' 
        eventTrackingParams.l = this.data?.insurerCode + '-' + this.data?.PromotionTitle
        eventTrackingParams.cd.insurer_name = this.data?.insurerCode
        eventTrackingParams.cd.product_name = this.data?. productName
        eventTrackingParams.cd.product_category = 'qdap'
        
        this.sendEventTracking(eventTrackingParams)
      }


  },
};
